import React, { useEffect, useState,useMemo  } from "react";
import { useParams, useNavigate  } from "react-router-dom";


import {
  ArrowRight,
  CalendarDays,
  MapPin,
  Building2,
  Users,
  BookOpen,
  GraduationCap,
  Mail,
  Phone,
  UserRound,
FileText,
ChevronLeft,
ChevronRight,
} from "lucide-react";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import API_BASE_URL from "../../../api/api";

// const API_BASE_URL =
//   window.location.hostname === "localhost" ||
//     window.location.hostname === "127.0.0.1"
//     ? "http://127.0.0.1:8000/api"
//     : "https://api.kunainital.ac.in/api";

const FACULTIES_API = `${API_BASE_URL}/faculties`;
// console.log('FACULTIES_API', FACULTIES_API);

const DEPARTMENTS_API = `${API_BASE_URL}/departments`;
const FACULTY_SYLLABUS_API = `${API_BASE_URL}/faculty-syllabus`;
const TEACHER_API = `${API_BASE_URL}/teachers`;

const slugify = (value = "") =>
  value
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const FacultiesOfArtsPages = () => {
  const { facultySlug, slug } = useParams();

  const [faculty, setFaculty] = useState(null);
  const [department, setDepartment] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [syllabuses, setSyllabuses] = useState([]);
  const [syllabusLoading, setSyllabusLoading] = useState(false);
  const [activeSyllabusTab, setActiveSyllabusTab] = useState("");
const syllabusGroups = useMemo(() => {
  return syllabuses.reduce((groups, syllabus) => {
    const type = syllabus.syllabus_type || "Other";

    if (!groups[type]) {
      groups[type] = [];
    }

    groups[type].push(syllabus);

    return groups;
  }, {});
}, [syllabuses]);

useEffect(() => {
  const types = Object.keys(syllabusGroups);

  if (types.length > 0) {
    setActiveSyllabusTab((prev) =>
      types.includes(prev) ? prev : types[0]
    );
  } else {
    setActiveSyllabusTab("");
  }
}, [syllabusGroups]);
 const [teachers, setTeachers] = useState([]);
const [teacherLoading, setTeacherLoading] = useState(false);
const [currentPage, setCurrentPage] = useState(1);
const [lastPage, setLastPage] = useState(1);
const [departmentHead, setDepartmentHead] = useState(null);
const [cv, setCV] = useState(null);

// console.log(teachers?.cv);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        setLoading(true);
        setError("");

        const [
          facultyResponse,
          departmentResponse,
        ] = await Promise.all([
          fetch(FACULTIES_API),
          fetch(DEPARTMENTS_API),
        ]);

        if (!facultyResponse.ok) {
          throw new Error(
            `Faculty API Error: ${facultyResponse.status}`
          );
        }

        if (!departmentResponse.ok) {
          throw new Error(
            `Department API Error: ${departmentResponse.status}`
          );
        }

        const facultyResult =
          await facultyResponse.json();

        const departmentResult =
          await departmentResponse.json();

        // console.log(
        //   "FACULTIES API:",
        //   facultyResult
        // );

        // console.log(
        //   "DEPARTMENTS API:",
        //   departmentResult
        // );

        if (
          !facultyResult.status ||
          !Array.isArray(facultyResult.data)
        ) {
          throw new Error(
            "Invalid faculty API response"
          );
        }

        if (
          !departmentResult.status ||
          !Array.isArray(departmentResult.data)
        ) {
          throw new Error(
            "Invalid department API response"
          );
        }

        /*
         * FIND FACULTY
         */
        const selectedFaculty =
          facultyResult.data.find(
            (item) =>
              Number(item.status) === 1 &&
              slugify(item.name) === facultySlug
          );

        /*
         * FIND DEPARTMENT
         */
        const selectedDepartment =
          departmentResult.data.find(
            (item) =>
              Number(item.status) === 1 &&
              slugify(item.name) === slug &&
              (
                !selectedFaculty ||
                Number(item.faculty_id) ===
                  Number(selectedFaculty.id)
              )
          );

        if (!selectedFaculty) {
          setError("Faculty not found.");
          setFaculty(null);
          setDepartment(null);
          return;
        }

        if (!selectedDepartment) {
          setError("Department not found.");
          setFaculty(selectedFaculty);
          setDepartment(null);
          return;
        }

        // console.log(
        //   "SELECTED FACULTY:",
        //   selectedFaculty
        // );

        // console.log(
        //   "SELECTED DEPARTMENT:",
        //   selectedDepartment
        // );

        setFaculty(selectedFaculty);
        setDepartment(selectedDepartment);
      } catch (err) {
        console.error(
          "Department page error:",
          err
        );

        setError(
          err.message ||
            "Unable to load department."
        );
      } finally {
        setLoading(false);
      }
    };

    if (facultySlug && slug) {
      fetchDepartment();
    }
  }, [facultySlug, slug]);
//  faculty syllabuss start

useEffect(() => {
  const fetchSyllabuses = async () => {
    if (!department?.id) return;

    try {
      setSyllabusLoading(true);

      const response = await fetch(
        `${FACULTY_SYLLABUS_API}?faculty_id=${department.faculty_id}&department_id=${department.id}`
      );

      if (!response.ok) {
        throw new Error("Faculty syllabus API error");
      }

      const result = await response.json();

      if (result.status && Array.isArray(result.data)) {
        setSyllabuses(result.data);
      } else {
        setSyllabuses([]);
      }
    } catch (error) {
      console.error("Faculty syllabus error:", error);
      setSyllabuses([]);
    } finally {
      setSyllabusLoading(false);
    }
  };

  fetchSyllabuses();
}, [department]);




// ================= TEACHER API =================
useEffect(() => {
  const fetchTeachers = async () => {
    if (!department?.id) {
      setTeachers([]);
      setDepartmentHead(null);
      return;
    }

    try {
      setTeacherLoading(true);
      setDepartmentHead(null);

      const url = `${TEACHER_API}?department_id=${department.id}&page=${currentPage}`;

      console.log("TEACHERS API URL:", url);
      console.log("CURRENT DEPARTMENT ID:", department.id);

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Teachers API Error: ${response.status}`);
      }

      const result = await response.json();

      console.log("TEACHERS API RESPONSE:", result);

      /*
       * Laravel pagination response:
       *
       * result.data.data = teachers
       */
      const teacherData = Array.isArray(result?.data?.data)
        ? result.data.data
        : Array.isArray(result?.data)
        ? result.data
        : [];

      console.log("ALL TEACHER DATA:", teacherData);

      /*
       * IMPORTANT
       * Filter teachers according to current department.
       */
      const departmentTeachers = teacherData.filter(
        (teacher) =>
          Number(teacher?.department?.id) === Number(department.id) ||
          Number(teacher?.department_id) === Number(department.id)
      );

      console.log(
        "CURRENT DEPARTMENT TEACHERS:",
        departmentTeachers
      );

      /*
       * FIND HEAD
       *
       * Prefer is_head if backend provides it.
       *
       * If is_head is not present, then designation
       * containing "Head" is used.
       */
      const head = departmentTeachers.find((teacher) => {
        const designationName =
          teacher?.designation?.name ||
          teacher?.designation ||
          "";

        return (
          Number(teacher?.is_head) === 1 ||
          teacher?.is_head === true ||
          designationName.toLowerCase().includes("head")
        );
      });

      console.log("DEPARTMENT HEAD:", head);

      setDepartmentHead(head || null);

      /*
       * Remove Head from normal faculty members.
       */
      const facultyMembers = departmentTeachers.filter(
        (teacher) => teacher.id !== head?.id
      );

      console.log(
        "NORMAL FACULTY MEMBERS:",
        facultyMembers
      );

      setTeachers(facultyMembers);

      /*
       * PAGINATION
       */
      const pagination = result?.data;

      setCurrentPage(pagination?.current_page || 1);
      setLastPage(pagination?.last_page || 1);

    } catch (error) {
      console.error("Teachers API Error:", error);

      setTeachers([]);
      setDepartmentHead(null);
      setLastPage(1);
    } finally {
      setTeacherLoading(false);
    }
  };

  fetchTeachers();
}, [department?.id, currentPage]);
// teacher section start


  /*
   * LOADING
   */
  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--paper)]">
        <Header />

        <div className="min-h-[500px] flex items-center justify-center">
          <div className="text-center">
            <div className="w-10 h-10 border-4 border-gray-200 border-t-[#B5121B] rounded-full animate-spin mx-auto mb-4" />

            <p className="text-gray-600 text-lg font-gill">
              Loading department...
            </p>
          </div>
        </div>

        <Footer />
      </div>

    
    );
  }

  /*
   * ERROR
   */
  if (error || !department) {
    return (
      <div className="min-h-screen bg-[var(--paper)]">
        <Header />

        <section className="min-h-[500px] flex items-center justify-center px-6">
          <div className="text-center max-w-xl">
            <h1 className="text-3xl font-bold text-[#08245c] mb-3">
              Department Not Found
            </h1>

            <p className="text-gray-600">
              {error ||
                "The requested department could not be found."}
            </p>
          </div>
        </section>

        <Footer />
      </div>
    );
  }

  /*
   * API DATA
   *
   * Different APIs may use different field names.
   * These fallbacks allow common names.
   */
  const departmentName =
    department.name ||
    department.title ||
    "Department";

  const facultyName =
    faculty?.name ||
    department.faculty_name ||
    "Faculty";

  const description =
    department.description ||
    department.details ||
    department.content ||
    department.about ||
    "";

  const vision =
    department.vision || "";

  const mission =
    department.mission || "";

  const objectives =
    department.objectives || "";

  const address =
    department.address ||
    department.location ||
    "";

  const email =
    department.email ||
    department.contact_email ||
    "";

  const phone =
    department.phone ||
    department.contact_number ||
    "";

  const image =
    department.image ||
    department.image_url ||
    "/images/campusKumaun.avif";

//     const syllabusGroups = syllabuses.reduce((groups, syllabus) => {
//   const type = syllabus.syllabus_type || "Other";

//   if (!groups[type]) {
//     groups[type] = [];
//   }

//   groups[type].push(syllabus);

//   return groups;
// }, {});


  /*
   * Convert HTML description to JSX
   * if API returns HTML.
   */
  const renderContent = (content) => {
    if (!content) return null;

    return (
      <div
        className="text-justify"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    );
  };

  return (
    <div className="min-h-screen bg-[var(--paper)]">
      <Header />

      {/* HERO */}
      <section className="relative h-[250px] overflow-hidden">
        <img
          src={image}
          alt={departmentName}
          className="absolute inset-0 w-full h-full object-cover"
          onError={(event) => {
            event.currentTarget.src =
              "/images/campusKumaun.avif";
          }}
        />

        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />

        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
          <div className="max-w-4xl text-white">
            {/* BREADCRUMB */}
            <div className="flex flex-wrap items-center gap-2 text-sm mb-5">
              <span className="text-[#123B5D] text-lg font-gill">
                Faculties
              </span>

              <span className="text-[#123B5D] text-lg font-gill">
                /
              </span>

              <span className="text-[#123B5D] text-lg font-gill">
                {facultyName}
              </span>

              <span className="text-[#123B5D] text-lg font-gill">
                /
              </span>

              <span className="text-[#123B5D] text-lg font-gill">
                {departmentName}
              </span>
            </div>

            {/* TITLE */}
            <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B]  font-gill">
              {departmentName.toUpperCase()}
            </h1>
          </div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          {/* ABOUT */}
          <div className="mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-[#08245c] mb-5 font-gill">
              About the {departmentName}
            </h2>

            {/* {description ? (
              <div className="space-y-5 text-[16px] leading-7 text-gray-700 text-lg font-gill">
                {renderContent(description)}
              </div>
            ) : (
              <p className="text-gray-500 text-lg font-gill">
                Department description is not available.
              </p>
            )} */}
           {description ? (
              <div>
                <div className="max-h-[180px] overflow-hidden text-[16px] leading-5 text-gray-700 text-lg font-gill">
                  {renderContent(description)}
                </div>

                <button
                  onClick={() =>
                   navigate(
                      `/department/${facultySlug}/${slugify(departmentName)}`
                    )
                  }
                  className="mt-5 inline-flex items-center font-gill text-[16px] bg-[#8B1E1E] text-white px-5 py-2 rounded-md font-semibold hover:bg-[#6F1717] transition-colors duration-200"
                >
                  Read More →
                </button>
              </div>
            ) : (
              <p className="text-gray-500 text-lg font-gill">
                Department description is not available.
              </p>
            )}
          </div>

          {/* VISION */}
          {vision && (
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#08245c] mb-3 font-gill">
                Vision
              </h3>

              <div className="text-[16px] leading-7 text-gray-700 text-justify text-lg font-gill">
                {renderContent(vision)}
              </div>
            </div>
          )}

          {/* MISSION */}
          {mission && (
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#08245c] mb-3">
                Mission
              </h3>

              <div className="text-[16px] leading-7 text-gray-700 text-justify">
                {renderContent(mission)}
              </div>
            </div>
          )}

          {/* OBJECTIVES */}
          {objectives && (
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#08245c] mb-3">
                Objectives
              </h3>

              <div className="text-[16px] leading-7 text-gray-700 text-justify">
                {renderContent(objectives)}
              </div>
            </div>
          )}

          {/* DETAILS */}
          {(address || email || phone) && (
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
              {address && (
                <div className="border border-gray-200 rounded-lg p-5">
                  <div className="flex items-start gap-3">
                    <MapPin
                      size={22}
                      className="text-[#B5121B] flex-shrink-0"
                    />

                    <div>
                      <h4 className="font-bold text-[#08245c] mb-1">
                        Address
                      </h4>

                      <p className="text-gray-600 text-sm">
                        {address}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {email && (
                <div className="border border-gray-200 rounded-lg p-5">
                  <div className="flex items-start gap-3">
                    <Mail
                      size={22}
                      className="text-[#B5121B] flex-shrink-0"
                    />

                    <div>
                      <h4 className="font-bold text-[#08245c] mb-1">
                        Email
                      </h4>

                      <a
                        href={`mailto:${email}`}
                        className="text-gray-600 text-sm hover:text-[#B5121B]"
                      >
                        {email}
                      </a>
                    </div>
                  </div>
                </div>
              )}

              {phone && (
                <div className="border border-gray-200 rounded-lg p-5">
                  <div className="flex items-start gap-3">
                    <Phone
                      size={22}
                      className="text-[#B5121B] flex-shrink-0"
                    />

                    <div>
                      <h4 className="font-bold text-[#08245c] mb-1">
                        Contact
                      </h4>

                      <a
                        href={`tel:${phone}`}
                        className="text-gray-600 text-sm hover:text-[#B5121B]"
                      >
                        {phone}
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </section>
{/* Teacher section start */}
 {/* Teachers and heads Api start */}
      {/* ================= TEACHERS & HEADS ================= */}
{/* ================= ABOUT THE HEAD ================= */}
<section className="bg-white py-20">
  <div className="max-w-7xl mx-auto px-6">

    {/* SECTION HEADING */}
    <div className="text-center mb-14">

      <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] font-gill">
        About the Head
      </h2>

      <div className="mt-4 mx-auto w-16 h-1 bg-[#8B1E1E] rounded-full"></div>
    </div>

    {/* LOADING */}
    {teacherLoading && (
      <div className="text-center py-14">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-[#B5121B] rounded-full animate-spin mx-auto mb-4"></div>

        <p className="text-gray-600 text-lg font-gill">
          Loading Head profile...
        </p>
      </div>
    )}

    {/* ================= DEPARTMENT HEAD ================= */}
    {!teacherLoading && departmentHead && (
      <div
        className="
          relative
          grid
          grid-cols-1
          lg:grid-cols-2
          gap-10
          lg:gap-14
          items-start
          bg-white
          rounded-3xl
          border
          border-gray-200
          shadow-md
          p-6
          md:p-8
          lg:p-10
          overflow-hidden
          hover:shadow-xl
          transition-shadow
          duration-300
        "
      >

        {/* ================= LEFT SIDE ================= */}
        <div className="relative">

          {/* Decorative Shape */}
          <div
            className="
              absolute
              -left-6
              -bottom-6
              w-[90%]
              h-[85%]
              rounded-3xl
              bg-[var(--saffron)]/15
            "
          />

          <div className="relative">

            {/* PROFILE IMAGE */}
            <div className="flex justify-start mb-7">
              <div
                className="
                  w-[300px]
                  h-[300px]
                  md:w-[300px]
                  md:h-[300px]
                  rounded-2xl
                  overflow-hidden
                  bg-[#EAF5EF]
                  border-4
                  border-white
                  shadow-lg
                "
              >

                {departmentHead.profile_photo ? (
                  <img
                    src={departmentHead.profile_photo}
                    alt={departmentHead.name || "Head"}
                    className="
                      w-full
                      h-full
                      object-cover
                      object-top
                    "
                    onError={(event) => {
                      event.currentTarget.style.display = "none";
                    }}
                  />
                ) : (
                  <div
                    className="
                      w-full
                      h-full
                      flex
                      items-center
                      justify-center
                      text-gray-400
                    "
                  >
                    <UserRound
                      size={75}
                      strokeWidth={1.5}
                    />
                  </div>
                )}

              </div>
            </div>

            {/* NAME */}
            <h3
              className="
                text-2xl
                md:text-3xl
                font-bold
                text-[#123B5D]
                mb-7
                font-gill
              "
            >
              {departmentHead.name || "Head"}
            </h3>

            {/* DETAILS */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">

              {/* DESIGNATION */}
              {departmentHead.designation?.name && (
                <div className="flex items-start gap-3">

                  <UserRound
                    size={20}
                    className="text-[#E52323] mt-1 flex-shrink-0"
                  />

                  <div>
                    <p className="text-sm text-gray-500 font-gill mb-1">
                      Designation
                    </p>

                    <p className="text-lg text-gray-700 font-gill">
                      {departmentHead.designation.name}
                    </p>
                  </div>

                </div>
              )}

              {/* FACULTY */}
              {departmentHead.faculty?.name && (
                <div className="flex items-start gap-3">

                  <GraduationCap
                    size={20}
                    className="text-[#E52323] mt-1 flex-shrink-0"
                  />

                  <div>
                    <p className="text-sm text-gray-500 font-gill mb-1">
                      Faculty
                    </p>

                    <p className="text-lg text-gray-700 font-gill">
                      {departmentHead.faculty.name}
                    </p>
                  </div>

                </div>
              )}

              {/* DEPARTMENT */}
              {departmentHead.department?.name && (
                <div className="flex items-start gap-3">

                  <Building2
                    size={20}
                    className="text-[#E52323] mt-1 flex-shrink-0"
                  />

                  <div>
                    <p className="text-sm text-gray-500 font-gill mb-1">
                      Department
                    </p>

                    <p className="text-lg text-gray-700 font-gill">
                      {departmentHead.department.name}
                    </p>
                  </div>

                </div>
              )}

              {/* EMAIL */}
              {departmentHead.email && (
                <div className="flex items-start gap-3">

                  <Mail
                    size={20}
                    className="text-[#E52323] mt-1 flex-shrink-0"
                  />

                  <div className="min-w-0">
                    <p className="text-sm text-gray-500 font-gill mb-1">
                      Email
                    </p>

                    <a
                      href={`mailto:${departmentHead.email}`}
                      className="
                        text-lg
                        text-gray-700
                        font-gill
                        break-all
                        hover:text-[#8B1E1E]
                      "
                    >
                      {departmentHead.email}
                    </a>
                  </div>

                </div>
              )}

              {/* MOBILE */}
              {departmentHead.mobile && (
                <div className="flex items-start gap-3">

                  <Phone
                    size={20}
                    className="text-[#E52323] mt-1 flex-shrink-0"
                  />

                  <div>
                    <p className="text-sm text-gray-500 font-gill mb-1">
                      Contact
                    </p>

                    <a
                      href={`tel:${departmentHead.mobile}`}
                      className="
                        text-lg
                        text-gray-700
                        font-gill
                        hover:text-[#8B1E1E]
                      "
                    >
                      {departmentHead.mobile}
                    </a>
                  </div>

                </div>
              )}
        {/* pdf start code */}
        {departmentHead.pdf && (
          <div className="flex items-start gap-3">
            <FileText
              size={20}
              className="text-[#E52323] mt-1 flex-shrink-0"
            />

            <div>
              <p className="text-sm text-gray-500 font-gill mb-1">
                PDF
              </p>

              <a
                href={departmentHead.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg text-gray-700 font-gill hover:text-[#8B1E1E] underline break-all"
              >
                View PDF
              </a>
            </div>
          </div>
        )}
        {/* pdf end code */}


            </div>
          </div>
        </div>

        {/* ================= RIGHT SIDE ================= */}
        <div className="lg:pt-2">

          <h3
            className="
              text-2xl
              md:text-3xl
              font-bold
              text-[#08245c]
              mb-6
              font-gill
            "
          >
            About {departmentHead.name || "Head"}
          </h3>

          {departmentHead.description ? (
            <div
              className="
                faculty-description
                text-gray-600
                text-lg
                leading-8
                text-justify
                font-gill
              "
              dangerouslySetInnerHTML={{
                __html: departmentHead.description,
              }}
            />
          ) : (
            <p className="text-gray-500 text-lg font-gill">
              Head profile description is not available.
            </p>
          )}

        </div>

      </div>
    )}

    {/* NO HEAD */}
    {!teacherLoading && !departmentHead && (
      <div className="text-center py-14">

        <UserRound
          size={55}
          className="mx-auto mb-4 text-gray-300"
        />

        <p className="text-gray-500 text-lg font-gill">
          No Head has been assigned to this department.
        </p>

      </div>
    )}

  </div>
</section>
{/* ================= END ABOUT THE HEAD ================= */}
{/* ================= END TEACHERS & HEADS ================= */}
{/* Teacher section start */}
      {/* FACULTY SYLLABUS */}
      {(syllabusLoading || Object.keys(syllabusGroups).length > 0) && (

  <section className="bg-[#f8fafc] py-12">
    <div className="max-w-7xl mx-auto px-6">

  {/* HEADING */}
  <div className="mb-8">
    <h2 className="text-3xl md:text-4xl font-bold text-[#08245c] font-gill">
      Ordinance Syllabus 
    </h2>
    <div className="mt-2 w-16 h-1 bg-[#8B1E1E] rounded-full"></div>
  </div>

  {syllabusLoading ? (
    <div className="text-center py-10">
      <div className="w-8 h-8 border-4 border-gray-200 border-t-[#B5121B] rounded-full animate-spin mx-auto mb-3"></div>
      <p className="text-gray-600 font-gill">
        Loading syllabus...
      </p>
    </div>
  ) : (
    <>
      {/* SYLLABUS TYPE TABS */}
      <div className="flex flex-wrap gap-2 mb-6 border-b border-gray-200 pb-3">
        {Object.keys(syllabusGroups).map((type) => (
          <button
            key={type}
            type="button"
            onClick={() => setActiveSyllabusTab(type)}
            className={`px-5 py-3 rounded-lg font-semibold font-gill text-sm md:text-base transition-all duration-200 ${
              activeSyllabusTab === type
                ? "bg-[#08245c] text-white shadow-md"
                : "bg-white text-[#08245c] border border-gray-200 hover:border-[#8B1E1E] hover:text-[#8B1E1E]"
            }`}
          >
            {type}
          </button>
        ))}
      </div>

      {/* ACTIVE TAB SYLLABUS */}
      {activeSyllabusTab &&
        syllabusGroups[activeSyllabusTab] && (
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">

            {/* ACTIVE TYPE HEADING */}
            <div className="bg-[#08245c] px-6 py-4">
              <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                {activeSyllabusTab}
              </h3>
            </div>

            {/* PDF LINKS */}
            <div className="p-4 md:p-6">
              <div className="grid grid-cols-1 gap-4">
                {syllabusGroups[activeSyllabusTab].map((syllabus) => (
                  <a
                    key={syllabus.id}
                    href={syllabus.pdf_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center justify-between gap-4 w-full border border-gray-200 rounded-lg px-4 md:px-5 py-4 hover:border-[#8B1E1E] hover:shadow-md transition-all duration-200"
                  >
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="w-10 h-10 flex-shrink-0 rounded-lg bg-red-50 flex items-center justify-center">
                        <BookOpen
                          size={20}
                          className="text-[#B5121B]"
                        />
                      </div>

                      <div className="min-w-0">
                        <p className="font-semibold text-[#08245c] font-gill break-words group-hover:text-[#8B1E1E]">
                          {syllabus.pdf_name || "View Syllabus"}
                        </p>
                        <p className="text-sm text-gray-500 font-gill">
                          PDF
                        </p>
                      </div>
                    </div>

                    <ArrowRight
                      size={20}
                      className="flex-shrink-0 text-gray-400 group-hover:text-[#8B1E1E] group-hover:translate-x-1 transition-all"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
    </>
  )}
</div>

  </section>
)}

     
{/* all department teacher start */}
{/* ================= FACULTY MEMBERS ================= */}
{/* ================= FACULTY MEMBERS ================= */}
{/* ================= FACULTY MEMBERS ================= */}
{/* ================= FACULTY MEMBERS ================= */}
<section className="bg-white py-20">
  <div className="max-w-7xl mx-auto px-6">

    {/* SECTION HEADING */}
    <div className="text-center mb-14">
      <p className="uppercase tracking-[0.2em] text-sm font-bold text-[var(--terracotta)] mb-3 font-gill">
        Our Faculty
      </p>

      <h2 className="text-4xl md:text-5xl font-bold text-[#1F3D2B] font-gill">
        Faculty Members
      </h2>

      <div className="w-20 h-1 bg-[var(--terracotta)] mx-auto mt-5 rounded-full" />
    </div>

    {/* LOADING */}
    {teacherLoading && (
      <div className="text-center py-10">
        <p className="text-gray-500 font-gill">
          Loading faculty members...
        </p>
      </div>
    )}

    {/* ================= FACULTY GRID ================= */}
    {!teacherLoading && teachers.length > 0 && (
      <div className="grid md:grid-cols-3 gap-6">

        {teachers.map((teacher) => (
          <div
            key={teacher.id}
            className="
              group
              relative
              bg-white
              rounded-2xl
              p-8
              border
              border-gray-200
              shadow-md
              hover:shadow-xl
              transition-all
              duration-300
              overflow-hidden
            "
          >

            {/* ================= DECORATIVE SHAPE ================= */}
            <div
              className="
                absolute
                -top-10
                -left-10
                w-32
                h-32
                rounded-full
                bg-[#EAF5EF]
                group-hover:bg-[#88bfe1]
                transition-all
                duration-300
              "
            />

            {/* ================= PHOTO ================= */}
            <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

              <div
                className="
                  relative
                  w-40
                  h-40
                  rounded-full
                  overflow-hidden
                  bg-[#EAF5EF]
                  shadow-sm
                  group-hover:shadow-lg
                  transition-all
                  duration-300
                "
              >
                {teacher.profile_photo ? (
                  <img
                    src={teacher.profile_photo}
                    alt={teacher.name || "Faculty Member"}
                    className="
                      w-full
                      h-full
                      object-cover
                      object-top
                      transition-all
                      duration-300
                      group-hover:scale-110
                    "
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <UserRound
                      size={65}
                      className="text-gray-400"
                    />
                  </div>
                )}
              </div>

            </div>

            {/* ================= NAME ================= */}
            <h3
              className="
                text-xl
                font-bold
                text-[#123B5D]
                mb-4
                group-hover:text-[#0B5D3B]
                transition-colors
                font-gill
              "
            >
              {teacher.name || "Faculty Member"}
            </h3>

            {/* ================= FACULTY DATA ================= */}
            <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

              {/* DESIGNATION */}
              {teacher.designation && (
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>

                  <p className="text-lg font-gill">
                    {typeof teacher.designation === "object"
                      ? teacher.designation?.name
                      : teacher.designation}
                  </p>
                </div>
              )}

              {/* FACULTY */}
              {teacher.faculty?.name && (
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>

                  <p className="text-lg font-gill">
                    {teacher.faculty.name}
                  </p>
                </div>
              )}

              {/* DEPARTMENT */}
              {teacher.department?.name && (
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-book-open text-[#E52323] text-[17px] mt-1 w-4"></i>

                  <p className="text-lg font-gill">
                    {teacher.department.name}
                  </p>
                </div>
              )}

              {/* EMAIL */}
              {teacher.email && (
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>

                  <p className="text-lg font-gill break-all">
                    {teacher.email}
                  </p>
                </div>
              )}

              {/* MOBILE */}
              {teacher.mobile && (
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>

                  <p className="text-lg font-gill">
                    {teacher.mobile}
                  </p>
                </div>
              )}

              {/* DESCRIPTION */}
              {teacher.description && (
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-circle-info text-[#E52323] text-[17px] mt-1 w-4"></i>

                  <div
                    className="
                      text-lg
                      font-gill
                      line-clamp-3
                    "
                    dangerouslySetInnerHTML={{
                      __html: teacher.description,
                    }}
                  />
                </div>
              )}
          {/* {teacher.pdf && (
            <div className="flex items-start gap-3">
              <i className="fa-solid fa-file-pdf text-[#E52323] text-[17px] mt-1 w-4"></i>

              <button
                href={teacher.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg font-gill text-blue-600 bg-red-600 hover:underline break-all"
              >
                View CV
              </button>
            </div>
          )}
             */}
         <div className="flex items-start gap-3">
  {/* <button
  type="button"
  onClick={() => {
    if (!teacher.encrypted_id) {
      console.error("Encrypted ID missing:", teacher);
      return;
    }

    navigate(`/teacher/${teacher.encrypted_id}/cv`);
  }}
  className="text-blue-600 hover:underline"
>
  View CV
</button> */}


{teacher?.cv != null && (
  <button
    type="button"
    onClick={() => {
      console.log("Teacher full data:", teacher);
      console.log("Teacher CV data:", teacher.cv);

      if (!teacher.encrypted_id) {
        console.error("Encrypted ID missing:", teacher);
        return;
      }

      const url = `/teacher/${teacher.encrypted_id}/cv`;
      window.open(url, "_blank", "noopener,noreferrer");
    }}
    className="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-md shadow-sm transition duration-200"
  >
    View CV
  </button>
)}

      </div>
         
            </div>

          </div>
        ))}

      </div>
    )}

    {/* ================= NO DATA ================= */}
    {!teacherLoading && teachers.length === 0 && (
      <div className="text-center py-10">
        <p className="text-gray-500 font-gill">
          No faculty members found.
        </p>
      </div>
    )}

    {/* ================= PAGINATION ================= */}
    {!teacherLoading && lastPage > 1 && (
      <div className="flex justify-center items-center gap-4 mt-12">

        {/* PREVIOUS */}
        <button
          type="button"
          disabled={currentPage === 1}
          onClick={() =>
            setCurrentPage((prev) => Math.max(prev - 1, 1))
          }
          className="
            flex
            items-center
            gap-2
            px-5
            py-2.5
            rounded-xl
            border
            border-gray-200
            text-[#1F3D2B]
            disabled:opacity-40
            disabled:cursor-not-allowed
            hover:bg-[#EAF5EF]
            transition
          "
        >
          <ChevronLeft size={18} />
          Previous
        </button>

        {/* PAGE */}
        <span className="font-semibold text-[#1F3D2B]">
          Page {currentPage} of {lastPage}
        </span>

        {/* NEXT */}
        <button
          type="button"
          disabled={currentPage === lastPage}
          onClick={() =>
            setCurrentPage((prev) =>
              Math.min(prev + 1, lastPage)
            )
          }
          className="
            flex
            items-center
            gap-2
            px-5
            py-2.5
            rounded-xl
            border
            border-gray-200
            text-[#1F3D2B]
            disabled:opacity-40
            disabled:cursor-not-allowed
            hover:bg-[#EAF5EF]
            transition
          "
        >
          Next
          <ChevronRight size={18} />
        </button>

      </div>
    )}

  </div>
</section>


      {/* =========================================================
          TEACHER DESCRIPTION SECTIONS
      ========================================================= */}

      
{/* all department teacher end */}
       {/* Teachers and heads Api start */}



{/* Teachers and heads Api end */}
      {/* Teachers and heads Api end */}

      <Footer />
    </div>
  );
};

export default FacultiesOfArtsPages;